import React, { useEffect, useRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import LoginHeader from './loginHeader/loginHeader';
import { useNavigate, useSearchParams } from 'react-router-dom';
import LoginContainer from 'pages/loginPage/components/loginContainer';
import { useTranslation } from 'react-i18next';
import SignupForm from 'pages/loginPage/forms/signupForm';
import { authApi } from 'app/api/authApi';
import { AxiosError } from 'axios';
import mobxStore from 'app/store/rootStore';
import { Typography } from '@mui/material';
import PrimaryButton from 'shared/lib/components/controls/buttons/primaryButton';
import LoginFooter from 'pages/loginPage/loginFooter/loginFooter';

export default observer(function RegistrationPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const [isCodeError, setIsCodeError] = useState(false);

  const codeRef = useRef(searchParams.get('code'));

  useEffect(() => {
    if (!codeRef.current) {
      navigate('/login');
    }

    const code = String(codeRef.current);
    setSearchParams({});

    const validate = async () => {
      try {
        await authApi.verifySignupLink({ code });
      } catch (err) {
        const axiosErr = err as AxiosError;

        if (axiosErr.response?.status === 400) {
          setIsCodeError(true);
          return;
        }

        mobxStore.notificationsStore.errorMessage = t(
          'notifications.errors.default'
        );
        console.error(err);
      }
    };

    validate();
  }, [navigate, t]);

  return (
    <LoginContainer>
      <LoginHeader
        isError={isCodeError}
        text={
          isCodeError ? t('noCategory.notValidLink') : t('login.createPassword')
        }
      ></LoginHeader>
      {isCodeError ? (
        <>
          <Typography
            variant="f14"
            color="error.main"
            sx={{ textAlign: 'center', fontWeight: 300 }}
          >
            Вы&nbsp;использовали неактуальную ссылку на&nbsp;регистрацию.
            Создайте новую или войдите в&nbsp;систему
          </Typography>

          <PrimaryButton
            sx={{
              width: 1,
            }}
            form="signupForm"
            variant="contained"
            type="submit"
            onClick={() => {
              navigate('/login#invite');
            }}
          >
            <Typography variant="f20">{t('login.makeRegistration')}</Typography>
          </PrimaryButton>

          <LoginFooter
            activeForm="invite"
            handleSwitchForm={() => {
              navigate('/login');
            }}
          ></LoginFooter>
        </>
      ) : (
        <SignupForm
          onSubmit={async (data) => {
            try {
              const { email } = await mobxStore.authStore.signup({
                ...data,
                code: codeRef.current || '',
              });

              await mobxStore.authStore.login({
                username: email,
                password: data.password,
              });
            } catch (e) {
              mobxStore.notificationsStore.errorMessage = t(
                'notifications.errors.default'
              );
              console.error(e);
            }
          }}
        ></SignupForm>
      )}
    </LoginContainer>
  );
});
